export const baseFontSize = '1rem'
